<template>
  <div class="language-selection-page">
    <div class="brand">
      <img src="/static/image/new/logo-title-img.png" alt="BETMGM">
    </div>
    <div class="language-prompt">
      <span>{{ $t('请选择你的语言') }}</span>
      <span class="language-prompt-separator">/</span>
      <span>{{ $t('选择你的语言') }}</span>
    </div>
    <div class="lang-panel">
      <button
        v-for="item in languageList"
        :key="item.lang"
        type="button"
        :class="['lang-option', { active: item.lang === lang }]"
        @click="select_lang(item)"
      >
        <span class="lang-value">
          <img src="/static/image/new/lang/lang-icon.svg" class="globe-icon" alt="">
          <span class="lang-label">{{ item.nameKey }}</span>
        </span>
        <span class="check-box">
          <svg v-if="item.lang === lang" viewBox="0 0 18 18" aria-hidden="true">
            <path d="M3.5 9.5 7.5 13l7-8" />
          </svg>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { setup as setupLocale } from '@/locales/index.js'
import { normalizeUiLocale } from '@/locales/language'
import { initKefu } from '@/common/utils'

export default {
  name: 'language-selection-startup',
  props: {
    startup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lang: '',
      languageList: [
        { nameKey: 'English', lang: 'en' },
        { nameKey: '简体中文', lang: 'zh-CN' },
        { nameKey: '繁體中文', lang: 'zh-TW' }
      ]
    }
  },
  mounted() {
    this.lang = normalizeUiLocale(localStorage.getItem('language'))
  },
  methods: {
    back() {
      window.history.go(-1)
    },
    select_lang(item) {
      const locale = normalizeUiLocale(item.lang)
      this.lang = locale
      setupLocale(locale)
      this.$i18n.locale = locale
      window.localStorage.setItem('language', locale)
      initKefu(locale)
      this.$emit('selected')

      if (!this.startup) {
        this.back()
      } else if (this.$route.path === '/language-selection') {
        this.$router.replace({ path: '/' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.language-selection-page {
  width: 100%;
  min-height: 100vh;
  padding: 0 .4rem;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC, sans-serif;
  background-image: url("/static/image/new/lang/lang-bg.png");
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;

  .brand {
    padding-top: 1.2rem;
    text-align: center;
    img {
      display: block;
      width: 4.56rem;
      height: auto;
      margin: 0 auto;
    }
  }

  .language-prompt {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1.2rem 0 .4rem;
    color: rgba(255, 255, 255, .78);
    font-size: .35rem;
    line-height: .5rem;
    white-space: nowrap;
  }

  .language-prompt-separator {
    margin: 0 .03rem;
  }

  .lang-panel {
    width: 100%;
    padding: .51rem;
    border: 1px solid transparent;
    border-radius: .5rem;
    background:
      linear-gradient(rgba(7, 7, 7, .95), rgba(7, 7, 7, .95)) padding-box,
      linear-gradient(180deg, #d8ad71 0%, #986d31 100%) border-box;
    box-shadow: 0 0 .35rem rgba(28, 28, 185, .4);
  }

  .lang-option {
    width: 100%;
    height: 1.43rem;
    margin: 0 0 .36rem;
    padding: 0 .4rem;
    border: 1px solid rgba(158, 158, 158, .68);
    border-radius: .24rem;
    background: rgba(7, 7, 7, .88);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font: inherit;
    text-align: left;
    appearance: none;

    &:last-child {
      margin-bottom: 0;
    }

    &.active {
      border-color: transparent;
      background:
        linear-gradient(rgba(7, 7, 7, .94), rgba(7, 7, 7, .94)) padding-box,
        linear-gradient(100deg, #f1ca58 0%, #7356ff 100%) border-box;
      box-shadow: 0 0 .28rem rgba(86, 78, 238, .58);
      .globe-icon {
        // 修改svg图片颜色
        filter: drop-shadow(1000px 0 0 #F4B34C);
        transform: translate(-1000px);
      }
    }
  }

  .lang-value {
    display: flex;
    align-items: center;
  }

  .globe-icon {
    width: .71rem;
    height: .71rem;
    margin-right: .3rem;
    fill: none;
    stroke: #989898;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2.4;
  }

  .active .globe-icon {
    stroke: #f5b83c;
  }

  .lang-label {
    font-size: .35rem;
    line-height: 1;
  }

  .check-box {
    width: .51rem;
    height: .51rem;
    border: 1px solid #888;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
  }

  .active .check-box {
    border-color: #f5c340;
  }

  .check-box svg {
    width: .3rem;
    height: .3rem;
    fill: none;
    stroke: #f5c340;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/language-selection-startup.vue